{
	"comingSoon": "À venir",
	"fileUpload": "Cliquez ou glissez ici pour joindre",
	"logo": "Logo",
	"noInformation": "Pas d'informations",
	"toggleProducts": "Non, seulement ce produit"
}
